class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const id = button.dataset.popup;
        const popup = document.getElementById(id);
        if (popup) {
          popup.classList.add('show');
          document.querySelector('.previewCart').classList.add('active-tool');
        }
      });
    });
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    console.log('🔧 CouponCode inizializzato');

    // Ripristina eventuale sconto salvato
    const storedDiscount = localStorage.getItem('storedDiscount');
    if (storedDiscount) {
      const discountInput = this.querySelector('input[name="discount"]');
      if (discountInput) {
        discountInput.value = storedDiscount;
        console.log('💾 Sconto ripristinato:', storedDiscount);
      }
    }

    const updateButton = this.querySelector('[data-update-coupon]');
    if (!updateButton) {
      console.error('❌ Bottone [data-update-coupon] non trovato');
      return;
    }

    updateButton.addEventListener('click', () => {
      this.val = this.querySelector('input[name="discount"]').value.trim();
      if (!this.val) {
        console.warn('⚠️ Nessun codice coupon inserito');
        return;
      }

      // Salva in localStorage
      localStorage.setItem('storedDiscount', this.val);
      console.log('💾 Coupon salvato in localStorage:', this.val);

      // Imposta flag per riaprire il cart dopo reload
      sessionStorage.setItem('openCartAfterReload', 'true');
      console.log('🚩 Flag openCartAfterReload impostato');

      // Chiude eventuale popup coupon
      document.querySelector('.popup-toolDown.show')?.classList.remove('show');
      document.querySelector('.previewCart')?.classList.remove('active-tool');

      // Applica il coupon
      console.log(`🌐 Applicazione coupon: /discount/${this.val}`);
      fetch(`/discount/${this.val}`)
        .then((r) => r.text())
        .then(() => this.updateShopifyCart())
        .then(() => {
          console.log('✅ Coupon applicato, ricarico pagina...');
          setTimeout(() => window.location.reload(), 400);
        })
        .catch((err) => {
          console.error('❌ Errore durante applicazione coupon:', err);
          sessionStorage.removeItem('openCartAfterReload');
        });
    });
  }

  updateShopifyCart() {
    console.log('📦 updateShopifyCart() chiamato');
    const body = JSON.stringify({
      attributes: { discount: this.val },
    });

    return fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('🛒 Carrello aggiornato:', data);
        return data;
      });
  }
}

customElements.define('coupon-code', CouponCode);

// ========================================
// GESTIONE RIAPERTURA CART DOPO RELOAD
// ========================================

// Funzione helper per aprire il cart drawer
// Funzione per aprire il cart sidebar principale
function openCartMenu() {
  console.log('🛒 Tentativo di apertura del cart menu...');

  const body = document.querySelector('body');
  const cartIcon = document.querySelector('[data-cart-sidebar]');
  
  // Metodo 1: aggiungi la classe al body (drawer)
  if (body && !body.classList.contains('cart-sidebar-show')) {
    body.classList.add('cart-sidebar-show');
    console.log('✅ Drawer cart aperto via body.classList');
    return true;
  }

  // Metodo 2: triggera il click sul bottone del cart (fallback)
  if (cartIcon) {
    cartIcon.click();
    console.log('✅ Drawer cart aperto via click su data-cart-sidebar');
    return true;
  }

  // Metodo 3: fallback sulla previewCart
  const previewCart = document.querySelector('.previewCart');
  if (previewCart) {
    previewCart.classList.add('active-tool');
    console.log('✅ Drawer cart aperto via .previewCart');
    return true;
  }

  console.warn('⚠️ Nessun metodo ha funzionato per aprire il cart menu');
  return false;
}

// Dopo reload → riapri il cart
window.addEventListener('DOMContentLoaded', () => {
  const shouldOpen = sessionStorage.getItem('openCartAfterReload');
  if (shouldOpen === 'true') {
    console.log('🚀 Riapertura cart dopo reload...');
    sessionStorage.removeItem('openCartAfterReload');

    setTimeout(openCartMenu, 200);
    setTimeout(openCartMenu, 600);
    setTimeout(openCartMenu, 1000);
  }
});

// Backup: controlla anche su window.load (in caso DOMContentLoaded sia già passato)
window.addEventListener('load', () => {
  console.log('🌐 window.load - controllo finale flag');
  
  const shouldOpenCart = sessionStorage.getItem('openCartAfterReload');
  if (shouldOpenCart === 'true') {
    console.log('✅ Flag ancora presente su load, ultimo tentativo');
    sessionStorage.removeItem('openCartAfterReload');
    
    const cartPopupId = sessionStorage.getItem('cartPopupId');
    sessionStorage.removeItem('cartPopupId');
    
    setTimeout(() => openCartMenu, 200);
    setTimeout(() => openCartMenu, 500);
  }
});